import {
  EGlobalTransactionMovement,
  GlobalTransaction
} from '@/modules/common/services/graphql/server/server.sdk';
import { parseFormattedDate } from '../../../helpers/parseFormattedDate';
import { hasDetails } from '../../../helpers/transaction';
import {
  TransactionRow,
  TransactionFiltersOption,
  FilterSelectOption
} from '../types';

export function parseTransaction(
  transaction: GlobalTransaction
): TransactionRow {
  return {
    ...transaction,
    hasDetails: hasDetails(transaction.type!.value, transaction.status!.value),
    parsedDate: parseFormattedDate(transaction.date.formatted),
    isCanceled:
      transaction.movement?.value === EGlobalTransactionMovement.Canceled
  };
}

export function parseFilterOptions(
  filterOptions: TransactionFiltersOption[]
): FilterSelectOption[] {
  return filterOptions.map(option => ({
    label: option.description,
    value: option.key
  }));
}
